export default __webpack_public_path__ + "static/punching-be1d53f0e5d892213fba1b14faa7d30e.svg";